import React, { useEffect, useState, useRef, useMemo } from "react";
import { categoryOptions } from "../../../services/category.services";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { menuItemList, deleteMenuItem, addMenuItem, editMenuItem, menuItemDetails, sortMenuItems, latest_menu_item_code, getAllUpsellingItems } from "../../../services/menuItem.services";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import { DISPLAY_METHOD_TAX_OPTIONS, LOADER_TIMEOUT_TIME, SOCKET_EVENTS, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { booleanMask, capitalizeFirstLetter, getTaxFromValue, getTranslatedKey, globalLoader, handleOffcanvasScroll, handleServerValidations, roundFigurePrice, showPrice, useDebouncing, TrimText } from "../../../../../utils/commonfunction";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { useFormik } from "formik";
import CustomError from "../../../../../utils/customError";
import { ReactSortable } from "react-sortablejs";
import { assignItems, Options } from "../../../services/addons.service";
import { Drawer, SelectPicker, Whisper, Tooltip } from "rsuite";
import GridLoader from "../../../shared/gridLoader";
import RecordNotFound from "../../../shared/recordNotFound";
import { useSelector } from "react-redux";
import { SOCKET_CLIENT } from "../../../../../utils/socket";
import { taxSettingOptions } from "../../../services/tax.services";
import { getRestaurantSettings } from "../../../services/profile.services";
import Select from 'react-select'
import { AllergenList } from "../../../../../utils/common.service";

export default function MenuItemListing() {
  const [categoryList, setCategoryList] = useState([]);
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const params = useParams();
  const [sortableCategories, setSortableCategories] = useState([]);
  const [search, setSearch] = useState({});
  const [refreshList, setRefreshList] = useState(false);
  const [List, setList] = useState([]);
  const sortingCloseBtn = useRef();
  const [loader, setLoader] = useState(true);
  const { t } = useTranslation();
  const { menuItemsValidationSchema } = useValidationSchemas();
  const navigate = useNavigate();
  const location = useLocation();
  const [ItemDetail, setItemDetail] = useState({});
  const [ItemOption, setItemOption] = useState([]);
  const [OptionsData, setOptionsData] = useState([]);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [langChanged, setLangChanged] = useState(false);
  const [menuItemCode, setMenuItemCode] = useState("");
  const restSettingDetails = useSelector((state) => state?.restSettings?.data);
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [openWithHeaderNextAdd, setOpenWithHeaderNextAdd] = useState(false);
  const [openWithHeaderNextModifierItemAdd, setOpenWithHeaderNextModifierItemAdd] = useState(false);
  const [openWithHeaderNextEdit, setOpenWithHeaderNextEdit] = useState(false);
  const [openWithHeaderNextModifierItemEdit, setOpenWithHeaderNextModifierItemEdit] = useState(false);
  const [upsellingItems, setUpsellingItems] = useState([]);
  const [filteredUpsellingItems, setFilteredUpsellingItems] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [allergenList, setAllergenList] = useState([]);
  const allergiesOptions = allergenList.map(item => ({
    value: item._id,
    label: item.name,
    logo: item.logo
  }));

  const addItemForm = useFormik({
    initialValues: {
      item_name: "",
      category_id: categoryList && categoryList.length ? categoryList[0]._id : "",
      item_code: menuItemCode,
      short_description: "",
      // selected_addon: "",
      selected_addon_id: -1,
      addons: [],
      taxable_price: 0,
      taxable_price_label: '',
      non_taxable_price: 0,
      non_taxable_price_label: '',
      vat: '',
      price: 0,
      cost_price: '',
      consumption_tax_rate: 0,
      // item_tax_type: ITEM_TAX_OPTIONS.INCLUSIVE,
      used_as_upselling_item: false,
      upselling_items: [],
      // spice_level_needed: false,
      image: "",
      type: "",
      allergies: [],
    },
    validationSchema: menuItemsValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setFieldValue }) => {

      if (openWithHeaderNextModifierItemAdd == false) {
        if (openWithHeaderNextAdd == true) {
          setOpenWithHeaderNextModifierItemAdd(true);
          return;
        } else if (openWithHeader == true) {
          setOpenWithHeaderNextAdd(true);
          return;
        }
      }

      setAddSubmissionLoader(true);
      const formData = new FormData();
      formData.append("item_name", values.item_name);
      formData.append("category_id", values.category_id);
      formData.append("item_code", values.item_code);
      formData.append("short_description", values.short_description);
      // formData.append("price", findTax()?.price_without_tax);
      formData.append("price", values.price);
      // formData.append("total_price", findTax()?.price_with_tax);
      formData.append("total_price", Number(findTax()?.price_with_tax) + Number(values.non_taxable_price));
      formData.append("price_with_tax", findTax()?.price_with_tax);
      formData.append("tax_price", findTax()?.tax_price);
      formData.append("cost_price", values.cost_price);
      formData.append("consumption_tax_rate", findTax()?.tax_rate);
      // formData.append("spice_level_needed", ITEM_TYPES.SET_OF_ITEMS !== values.type ? values.spice_level_needed : null);
      formData.append("image", values.image);
      // formData.append("item_tax_type", values.item_tax_type);
      formData.append("addons", JSON.stringify(values.addons));
      formData.append("original_amount", values.price);
      formData.append("taxable_price", values.taxable_price);
      formData.append("non_taxable_price", values.non_taxable_price);
      formData.append("taxable_price_label", values.taxable_price_label);
      formData.append("non_taxable_price_label", values.non_taxable_price_label);
      formData.append("used_as_upselling_item", values.used_as_upselling_item);
      formData.append("upselling_items", JSON.stringify(values.upselling_items));
      formData.append("allergies", JSON.stringify(values.allergies));
      addMenuItem(formData)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setFieldValue("image", "");
            resetForm();
            resetOptions();
            setOpenWithHeaderNextModifierItemAdd(false);
            setOpenWithHeaderNextAdd(false);
            setOpenWithHeader(false);
            // document.getElementById("image").value = "";
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          setAddSubmissionLoader(false);
        })
        .catch((error) => {
          console.error("Error updating profile", error);
          setAddSubmissionLoader(false);
        });

    },
  });

  const editItemForm = useFormik({
    initialValues: {
      o_id: "",
      item_name: "",
      category_id: "",
      item_code: "",
      short_description: "",
      selected_addon_id: "",
      addons: [],
      taxable_price: 0,
      non_taxable_price: 0,
      taxable_price_label: '',
      non_taxable_price_label: '',
      price: 0,
      cost_price: 0,
      consumption_tax_rate: 0,
      // item_tax_type: "",
      // spice_level_needed: "",
      image: "",
      type: "",
      used_as_upselling_item: "",
      upselling_items: [],
      allergies: [],
    },
    validationSchema: menuItemsValidationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setFieldValue }) => {

      if (openWithHeaderNextModifierItemEdit == false) {
        if (openWithHeaderNextEdit == true) {
          setOpenWithHeaderNextModifierItemEdit(true);
          return;
        } else if (openWithHeaderEdit == true) {
          setOpenWithHeaderNextEdit(true);
          return;
        }
      }

      setEditSubmissionLoader(true);
      const formData = new FormData();
      formData.append("o_id", values.o_id);
      formData.append("item_name", values.item_name);
      formData.append("category_id", values.category_id);
      formData.append("item_code", values.item_code);
      formData.append("short_description", values.short_description);
      // formData.append("price", findTax(editItemForm, values.category_id)?.price_without_tax);
      formData.append("price", values.price);
      // formData.append("total_price", findTax(editItemForm, values.category_id)?.price_with_tax);
      formData.append("total_price", findTax(editItemForm)?.price_with_tax + values.non_taxable_price);
      formData.append("price_with_tax", findTax(editItemForm)?.price_with_tax);
      formData.append("tax_price", findTax(editItemForm)?.tax_price);
      formData.append("cost_price", values.cost_price);
      formData.append("consumption_tax_rate", findTax(editItemForm, values.category_id)?.tax_rate);
      // formData.append("spice_level_needed", ITEM_TYPES.SET_OF_ITEMS !== values.type ? values.spice_level_needed : null);
      formData.append("used_as_upselling_item", values?.used_as_upselling_item);
      formData.append("image", values.image);
      // formData.append("item_tax_type", values.item_tax_type);
      formData.append("addons", JSON.stringify(values.addons));
      formData.append("original_amount", values.price);
      formData.append("taxable_price", values.taxable_price);
      formData.append("non_taxable_price", values.non_taxable_price);
      formData.append("taxable_price_label", values.taxable_price_label);
      formData.append("non_taxable_price_label", values.non_taxable_price_label);
      formData.append("upselling_items", JSON.stringify(values.upselling_items));
      formData.append("allergies", JSON.stringify(values.allergies));
      editMenuItem(formData)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setFieldValue("image", "");
            resetForm();
            resetOptions();
            setOpenWithHeaderNextModifierItemEdit(false);
            setOpenWithHeaderNextEdit(false);
            setOpenWithHeaderEdit(false);
            // document.getElementById("image").value = "";
            // setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          setEditSubmissionLoader(false);
        })
        .catch((error) => {
          console.error("Error updating profile", error);
          setEditSubmissionLoader(false);
        });

    },
  });

  useEffect(() => {
    getRestaurantSettings()
      .then((response) => {
        setTimeout(() => {
        }, LOADER_TIMEOUT_TIME);
        setSettingsData(response && response?.data ? response?.data : {});
      })
      .catch((error) => {
        setTimeout(() => {
        }, LOADER_TIMEOUT_TIME);
        console.log("Error===>", error);
      });

    AllergenList().then((response) => {
      setAllergenList(response.data);
    }).catch((err) => {
      console.log(err)
    })
  }, []);


  const findTax = (form = addItemForm, categoryId = null) => {

    // const category = categoryList.find((obj) => obj?._id === (categoryId ? categoryId : form.values.category_id));
    let result = {
      tax_price: 0,
      price_without_tax: 0,
      price_with_tax: 0,
      tax_rate: 0,
    };

    const category = categoryList.find((obj) => obj?._id === (categoryId ? categoryId : form.values.category_id));
    if (category || form?.values?.consumption_tax_rate) {
      result.tax_rate = category ? (settingsData[category?.tax_type] || 0) : form?.values?.consumption_tax_rate;
      result.tax_price = (form?.values?.taxable_price * result.tax_rate) / 100;
      result.price_with_tax = form?.values?.taxable_price + result.tax_price;
    }

    return result;

  };

  useEffect(() => {
    categoryOptions(true)
      .then((response) => {
        setCategoryList(response?.data ? response.data.filter((record) => !record?.is_unCategorized) : []);
        setCategoryFilterOptions(response?.data ? response.data : []);
      })
      .catch((err) => {
        console.log(err);
      });

    Options()
      .then((response) => {
        const formattedOptions = response.data.map((item, i) => ({
          label: item.addon_name,
          value: item._id,
          assigned_items: item.assigned_items,
          disabled: !item.assigned_items.length ? true : false
        }));
        setItemOption(response.data);
        setOptionsData(formattedOptions);
      })
      .catch((err) => {
        console.log(err);
      });

    
  }, [langChanged]);



  const resetOptions = () => {
    const formattedOptions = ItemOption?.map((item, i) => ({
      label: item.addon_name,
      value: item._id,
      assigned_items: item.assigned_items,
      disabled: !item.assigned_items.length ? true : false
    }));
    setOptionsData(formattedOptions);
  }

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
  const prepareGlobalSearch = (value) => {
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  const getMenuItemList = () => {
    setLoader(true);
    const formData = new FormData();
    const o_id = params.id ? params.id : "";

    if (Object.keys(search).length) {
      formData.append("search", JSON.stringify(search));
    }
    formData.append("global_search", globalSearch);
    if (params.id) {
      formData.append("category_id", o_id);
    }
    menuItemList(formData)
      .then((data) => {
        setList(data && data.data && data.data.list ? data.data.list : []);
        setSortableCategories(data && data.data && data.data.list ? data.data.list : []);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch((error) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log("error ====> ", error);
      });
  }
  const getUpsellingItems = () => {
    getAllUpsellingItems()
      .then((response) => {
        setUpsellingItems(response.data.upselling_items);
        setFilteredUpsellingItems(response.data.upselling_items);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getMenuItemList();
    getUpsellingItems();
  }, [search, refreshList, location, globalSearch, langChanged]);

  const deleteItem = (item) => {
    Swal.fire({
      title: t("restaurant.menu.delete_msg_are_you_sure"),
      text: t("restaurant.menu.btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("restaurant.menu.btn_delete"),
      cancelButtonText: t("restaurant.menu.btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteMenuItem({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
        setSortableCategories(List);
      }
    });
  };

  const get_menu_item_code = () => {
    latest_menu_item_code()
      .then((response) => {
        setMenuItemCode(response.data.item_code);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getItemDetail = (item) => {
    menuItemDetails({ o_id: item._id })
      .then((response) => {
        if (response.success) {

          let activeAddons = [];
          response?.data?.addons?.forEach(addon => {
            const addonExists = getAddon(addon?.addon_id);

            if (addonExists) {

              const disabled_items = [];
              const activeAssignedItems = addon?.assigned_items?.filter(assignedItem => {
                if (addonExists?.assigned_items?.includes(assignedItem?.item_name)) {
                  disabled_items.push(assignedItem?.item_name);
                  return true;
                }
                return false;
              });

              if (activeAssignedItems.length) {

                //disabling the added addon from the available options
                OptionsData?.forEach(optionData => {
                  if (optionData.value == addonExists._id) {
                    optionData.disabled = true;
                  }
                })

                activeAddons.push({
                  addon_id: addonExists._id,
                  addon_name: addonExists.addon_name,
                  assigned_items: activeAssignedItems,
                  total_items: addonExists.assigned_items,
                  disabled_items: disabled_items,
                  current_item: '',
                  current_item_price: ''
                })
              }
            }
          })
          setOptionsData(OptionsData);

        
          editItemForm.setValues({
            o_id: response?.data?._id || "",
            item_name: response?.data?.item_name || "",
            category_id: response?.data?.category_id || "",
            item_code: response?.data?.item_code || "",
            short_description: response?.data?.short_description || "",
            addons: activeAddons || [],
            // price: response?.data?.total_price && response?.data?.item_tax_type === ITEM_TAX_OPTIONS.INCLUSIVE ? response?.data?.total_price : response?.data?.price,
            price: response?.data?.price,
            cost_price: response?.data?.cost_price || 0,
            consumption_tax_rate: response?.data?.consumption_tax_rate || 0,
            // item_tax_type: response?.data?.item_tax_type || ITEM_TAX_OPTIONS.INCLUSIVE,
            used_as_upselling_item: response?.data?.used_as_upselling_item || false,
            // spice_level_needed: response?.data?.spice_level_needed || false,
            image: response?.data?.image || "",
            taxable_price: response?.data?.taxable_price || 0,
            non_taxable_price: response?.data?.non_taxable_price || 0,
            taxable_price_label: response?.data?.taxable_price_label || '',
            non_taxable_price_label: response?.data?.non_taxable_price_label || '',
            upselling_items: response?.data?.upselling_items,
            allergies: response?.data?.allergies || [],
          });

          setItemDetail(response?.data);

          // const upsellingItemsExclusiveCurrent = filteredUpsellingItems.filter(upsellingItem => upsellingItem._id != item._id);
          // setFilteredUpsellingItems(upsellingItemsExclusiveCurrent);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  function handleSortCategories(closeModal = true) {
    sortMenuItems({ sorted_array: sortableCategories })
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          if (closeModal) {
            sortingCloseBtn?.current?.click();
          }
          setRefreshList(!refreshList);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.error("Error updating profile", error);
      });
  }
  function isSortingChanged() {
    let changed = false;
    let i = 0;
    for (i; i < List.length; i++) {
      if (List[i]?.order !== sortableCategories[i]?.order) {
        changed = true;
        break;
      } else {
        changed = false;
      }
    };
    return changed;
  }
  const handleCloseSorting = () => {
    if (isSortingChanged()) {
      Swal.fire({
        title: t("question_to_save_data"),
        text: t("confirm_heading_found_unsaved_data_description"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#6c757d",
        cancelButtonColor: "#dc3545",
        confirmButtonText: t("btn_text_save_changes"),
        cancelButtonText: t("btn_text_discard"),
        customClass: {
          popup: "swal-restaurant",
          confirmButton: "btn btn-secondary col",
          cancelButton: "btn btn-danger col",
        },
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          handleSortCategories(false);
        } else {
          setSortableCategories(List);
        }
      });
    }
  };

  const addAddon = (form) => {
    let addons = [...form?.values?.addons];
    if (form?.values?.selected_addon_id != -1) {
      // const option = OptionsData.find(option => option.value == form?.values?.selected_addon_id);

      //also disabling the addon
      let option;
      OptionsData?.forEach(optionData => {
        if (optionData.value == form?.values?.selected_addon_id) {
          option = optionData;
          optionData.disabled = true;
        }
      })

      setOptionsData(OptionsData);

      if (!option) return;
      addons.push({
        addon_id: option.value,
        addon_name: option.label,
        total_items: option.assigned_items,
        assigned_items: [{ item_name: '', item_price: '' }],
        // assigned_items : [],
        disabled_items: [],
        current_item: '',
        current_item_price: 0
      });
      form?.setFieldValue("addons", addons);
      form?.setFieldValue("selected_addon_id", -1);
    }
  };

  const removeAddon = (addonIndex, form) => {
    let addons = [...form?.values?.addons];
    const addon = addons[addonIndex];

    //enabling the disables addon
    OptionsData?.forEach(optionData => {
      if (optionData.value == addon?.addon_id) {
        optionData.disabled = false;
      }
    })
    setOptionsData(OptionsData);

    const newAddons = addons.filter((addon, index) => index != addonIndex)
    form?.setFieldValue("addons", newAddons);
  };

  const getAddon = (id) => {
    return ItemOption.find((item) => item?._id === id);
  };

 

  const addAddOnItem = (index, form) => {
    if (index < form?.values?.addons.length) {
      let addons = [...form?.values?.addons];
      addons[index].assigned_items.push({ item_name: '', item_price: '' });
      form?.setFieldValue("addons", addons);
    }
  }

  const selectUpsellingItem = (itemId, form) => {
    let upselling_items = [...form?.values?.upselling_items];

    if (upselling_items.includes(itemId)) {
      upselling_items = upselling_items.filter(
        upsellingItemId => itemId != upsellingItemId
      );
    } else {
      upselling_items?.push(itemId);
    }
    form.setFieldValue('upselling_items', upselling_items);
  }
  const filterUpsellingItems = (searchedValue) => {
    searchedValue = searchedValue.trim().toLowerCase();
    const filteredRecords = upsellingItems?.filter(item => {
      return item?.item_name?.toLowerCase()?.includes(searchedValue);
    })
    setFilteredUpsellingItems(filteredRecords);
  }

  useMemo(() => {
    document.addEventListener("language_change", function () {
      setLangChanged(!langChanged);
    });
  });

  const disabledOptions = (values) => {
    // if (values?.addons?.length) {
    //   return values?.addons.map((op) => op.addon_id);
    // }
    // return [];
    const disabledIds = [];
    ItemOption.forEach((addon) => {
      let addonSelectedOptions = values?.addons.filter((op) => op.addon_id === addon?._id);
      if (addonSelectedOptions?.length === addon?.assigned_items?.length) {
        disabledIds.push(addon?._id);
      }
    });
    return disabledIds;
  };

  const isOptionSelected = (item, option, addons = []) => {
    if (addons.length) {
      let result = addons.filter(record => record?.addon_id === item?.addon_id && record?.item_id === option?._id);
      return result.length > 0;
    }
    return false
  };




  useMemo(() => {
    SOCKET_CLIENT.on('GET-DATA', (response) => {
      const eventData = response.data;
      if (response.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
        getMenuItemList();
        if (selectedMenuItem) {
          getItemDetail(selectedMenuItem);
        }
      }
    });
  }, [List]);

  const isValidAddons = (addons) => {
    for (let i = 0; i < addons.length; i++) {
      const result = addons[i].assigned_items.filter(record => {
        return !record?.item_name || !record?.item_price;
      });
      if (result.length > 0) {
        return false;
      }
    }
    return true;
  };

  return (
    <main id="main-content">
      {/* main container  */}
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">
            {t("Items")}
          </h4>
        </div>
        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          <div className="search-box">
            <input
              type="text"
              className="form-control search-input"
              placeholder={t("Search")}
              onInput={(e) => {
                searchDebounce(e.target.value);
              }}
            />
          </div>
          <div className="card-head-group d-flex align-items-center gap-2">
            <div className="tabls-dowpdown">
              <select
                className="form-control cp"
                value={params.id || ""}
                onChange={(e) => {
                  navigate(`/restaurant/menu/menu-item/list/${e.target.value}`);
                }}
              >
                <option disabled="" value="">
                  {t("Select Category")}
                </option>
                {categoryFilterOptions.map((item, index) => {
                  return (
                    <option key={index} value={item?._id}>
                      {/* {getTranslatedKey('name', item)} */}
                      {capitalizeFirstLetter(item?.name)}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#sort-modal">
              {t("Sort Menu Items")}
            </button> */}
            <button
              onClick={() => {
                setOpenWithHeader(true);
                get_menu_item_code();
              }}
              className="btn btn-primary"
            >
              <i className="ti ti-plus"></i> {t("Create New Item")}
            </button>
          </div>
        </div>
        {loader ? (
          <GridLoader innerClass='bg-base-color' />
        ) : (
          <div className="dashboard-content-wraper">
            {List.length > 0 ? (
              <div className="category-list-wrap">
                <div className="category-list-grid menu-list-grid">
                  {List.map((item, index) => (
                    <div className="category-box category-menu-box" key={index}>
                      <div className="category-name menu-img">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="menu-item-info d-flex align-items-center">
                        <h4 className="w-100 text-start 123">{TrimText(getTranslatedKey('item_name', item), 20)}</h4>
                        <div className="dropdown flex-1">
                          <button className="btn-icon show" type="button" data-bs-toggle="dropdown" aria-expanded="true">
                            <i className="ti ti-dots-vertical"></i>
                          </button>
                          <ul className="dropdown-menu ">
                            <li>
                              <button
                                className="dropdown-item"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#view-new-item"
                                onClick={() => {
                                  setSelectedMenuItem(item);
                                  getItemDetail(item);
                                }}
                              >
                                <i className="ti ti-eye"></i>
                                View
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  setSelectedMenuItem(item);
                                  getItemDetail(item);
                                  setOpenWithHeaderEdit(true);
                                }}
                              >
                                <i className="ti ti-edit"></i>
                                Edit
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item"
                                onClick={() => {
                                  deleteItem(item);
                                }}
                                type="button"
                              >
                                <i className="ti ti-trash"></i>
                                Delete
                              </button>
                            </li>
                          </ul>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <RecordNotFound heading="No Item found" />
            )}
          </div>
        )}
      </div>

      {/* sorting modal */}

      <div className="modal fade sort-modal" data-bs-backdrop="static" id="sort-modal" tabIndex="-1" aria-labelledby="sort-modalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {t("Menu Items")}{" "}
              </h1>

              <button type="button" className="btn-close btn-icon" onClick={handleCloseSorting} data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body">
              {sortableCategories && sortableCategories.length ? (
                <ReactSortable
                  list={sortableCategories}
                  setList={(newList) => setSortableCategories(newList)}
                  ghostClass="dropArea"
                  handle=".dragHandle"
                  filter=".ignoreDrag"
                  preventOnFilter={true}
                  className="grid-drag-container"
                >
                  <>
                    {sortableCategories.map((record, i) => (
                      <div className="category-box category-menu-box dragHandle" key={i} style={{ background: record?.color }}>
                        <div className="category-name menu-img">
                          <img src={record.image} alt="" />
                        </div>
                        <div className="menu-item-info">
                          <h4>{getTranslatedKey('item_name', record)}</h4>
                          {/* {record.item_name} */}
                          <span>£ {restSettingDetails?.display_method_product_price === DISPLAY_METHOD_TAX_OPTIONS.TAX_EXCLUDED ? showPrice(record?.price) : showPrice(record?.total_price)}</span>
                          {/* <span>£ {record.total_price?.toFixed(2)}</span> */}
                        </div>
                      </div>
                    ))}
                  </>
                </ReactSortable>
              ) : (
                <RecordNotFound heading="No menu item found" text="It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout." />
              )}
            </div>
            <div className="modal-footer justify-content-center">
              <button type="button" className="btn btn-danger me-2 d-none" data-bs-dismiss="modal" ref={sortingCloseBtn} aria-label="Close">
                Close
              </button>

              <button type="button" className="btn btn-primary" disabled={!isSortingChanged()} onClick={handleSortCategories}>
                {t("Save")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Add Item Modal 1 */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Create New Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeader(false);
                addItemForm.resetForm();
                resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editNewEmail", "rsuite");
          }}
        >
          <form onSubmit={addItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("Choose Category")}
                <span>*</span>{" "}
              </label>
              <select

                className="form-control cp"
                name="category_id"
                value={addItemForm?.values?.category_id}
                onChange={(e) => {
                  addItemForm.handleChange(e);
                  addItemForm.setFieldValue("consumption_tax_rate", findTax(addItemForm, e.target.value)?.tax_rate);
                }}
                onBlur={addItemForm.handleBlur}
              >
                <option value={""}>{t("Select")}</option>
                {categoryList.map((item, index) => {
                  return (
                    <option key={index} value={item?._id}>
                      {TrimText(item?.name, 50)}
                    </option>
                  );
                })}
              </select>
              <CustomError name="category_id" form={addItemForm} className="text-danger" />
            </div>

            {/* Allergies Multiselect */}
            <div className="mb-3">
              <label className="form-label">Allergies Selection
              </label>

              <Select
                isMulti
                name="allergies"
                className="basic-multi-select"
                classNamePrefix="select"
                options={allergiesOptions}

                /* 🔹 Convert stored values to option objects */
                value={allergiesOptions.filter(option =>
                  addItemForm.values.allergies?.includes(option.value)
                )}

                /* 🔹 Store only values in Formik */
                onChange={(selectedOptions) =>
                  addItemForm.setFieldValue(
                    "allergies",
                    selectedOptions ? selectedOptions.map(opt => opt.value) : []
                  )
                }

                formatOptionLabel={(option) => (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {option.imageUrl && (
                      <img
                        src={option.imageUrl}
                        alt={option.label}
                        style={{ width: "22px", height: "22px", borderRadius: "50%" }}
                      />
                    )}
                    <span>{option.label}</span>
                  </div>
                )}
              />

              <CustomError name="allergies" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Menu Item Code")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Menu Item Code") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Enter menu item code")}
                name="item_code"
                value={addItemForm?.values?.item_code}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
                disabled
              />
              <CustomError name="item_code" form={addItemForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">
                {t("Name Of The Item")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Name Of The Item") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Enter name of the item")}
                name="item_name"
                value={addItemForm?.values?.item_name}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
              />
              <CustomError name="item_name" form={addItemForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">
                {t("Add Photo")}
                <span>*</span>
              </label>
              <input
                className="form-control imgInput"
                id="image"
                name="image"
                accept="image/*"
                type="file"
                // value={addItemForm?.values?.image}
                onChange={(event) => {
                  addItemForm.setFieldValue("image", event.target.files[0] || "");
                }}
              />

              <CustomError name="image" form={addItemForm} className="text-danger" />
              <span className="mt-2 d-block">{t("Only JPEF, PNG files with max size 1.5 MB , Resolution supported 300X200")}</span>
              {addItemForm.values.image && (
                <ul className="question-image-preview questions-ul">
                  <li className="pr_img_box">
                    <img src={URL.createObjectURL(addItemForm.values.image)} style={{ height: "100px" }} alt={"Profile_Img"} />
                    <button
                      type="button"
                      className="btn-icon"
                      style={{ position: "absolute", right: "5px", top: "5px", height: "30px", width: "30px", minWidth: "30px" }}
                      onClick={() => {
                        addItemForm.setFieldValue("image", null);
                        document.getElementById("image").value = "";
                      }}
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </li>
                </ul>
              )}
            </div>

            {/* vatable price or non vatable price  <<<< */}
            <div className="mb-3">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Vatable Price")}
                    <span>*</span>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Vatable price") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price")}
                      aria-label="Vatable Price"
                      aria-describedby="basic-addon1"
                      name="taxable_price"
                      value={addItemForm?.values?.taxable_price}
                      onChange={(event) => {
                        addItemForm.handleChange(event);
                        addItemForm.setFieldValue('price', Number(addItemForm?.values?.non_taxable_price) + Number(event.target.value))
                      }}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                  <CustomError name="taxable_price" form={addItemForm} className="text-danger" />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Vatable Price Label")}
                    {/* <span>*</span> */}
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Vatable price label") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price label")}
                      aria-label="Vatable Price Label"
                      aria-describedby="basic-addon2"
                      name="taxable_price_label"
                      value={addItemForm?.values?.taxable_price_label}
                      onChange={addItemForm.handleChange}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                  {/* <CustomError name="taxable_price_label" form={addItemForm} className="text-danger" /> */}
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Non Vatable Price")}
                    <span>*</span>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Non vatable price") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter non vatable price")}
                      aria-label="Vatable Price"
                      aria-describedby="basic-addon1"
                      name="non_taxable_price"
                      value={addItemForm?.values?.non_taxable_price}
                      onChange={(event) => {
                        addItemForm.handleChange(event);
                        addItemForm.setFieldValue('price', Number(addItemForm?.values?.taxable_price) + Number(event.target.value))
                      }}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                  <CustomError name="non_taxable_price" form={addItemForm} className="text-danger" />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Non Vatable Price Label")}
                    {/* <span>*</span> */}
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Non vatable price label") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price label")}
                      aria-label="Non vatable Label"
                      aria-describedby="basic-addon2"
                      name="non_taxable_price_label"
                      value={addItemForm?.values?.non_taxable_price_label}
                      onChange={addItemForm.handleChange}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                  {/* <CustomError name="non_taxable_price_label" form={addItemForm} className="text-danger" /> */}
                </div>
              </div>
            </div>
            {/* vatable price or non vatable price  <<<< */}
            <div className="mb-3">
              <label className="form-label">
                {t("Price")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Price") + " " + t("Tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter price")}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      name="price"
                      value={addItemForm?.values?.price}
                      disabled
                      // onChange={addItemForm.handleChange}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                </div>
                
                <CustomError name="price" form={addItemForm} className="text-danger" />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Cost price")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Cost price") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  £
                </span>
                <input
                  type="number"
                  className="form-control no_spring_input"
                  placeholder={t("Enter cost price")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="cost_price"
                  value={addItemForm?.values?.cost_price}
                  onChange={addItemForm.handleChange}
                  onBlur={addItemForm.handleBlur}
                />
              </div>
              <CustomError name="cost_price" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Vat")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Vat") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter cost price"
                value={`${addItemForm?.values?.consumption_tax_rate}% Vat`}
                disabled
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={addItemForm?.values?.used_as_upselling_item}
                onChange={(e) => {
                  addItemForm?.setFieldValue("used_as_upselling_item", e.target.checked);
                }}
                id="used_as_upselling_item"
              />
              <label className="form-check-label" htmlFor="used_as_upselling_item">
                {t("Can be used as a upselling item?")}
              </label>
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between">
                {/* <span>{t("Calculated tax label")}</span> */}
                <span>{t("Calculated vat")}</span>
                <span>{addItemForm?.values?.category_id ? `£ ${showPrice(findTax()?.tax_price)}` : null}</span>
                {/* <span>£ {editItemForm?.values?.category_id ? showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.tax_price) : null}</span> */}
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("Price with vat")}</span>
                <span>{addItemForm?.values?.category_id ? `£ ${showPrice(findTax()?.price_with_tax)}` : null}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("Price without vat")}</span>
                {/* <span>£ {showPrice(findTax()?.price_without_tax)}</span> */}
                <span>£ {addItemForm?.values?.non_taxable_price}</span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Short description")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description"
                value={addItemForm?.values?.short_description}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
                placeholder="Enter short description"
              ></textarea>
              <CustomError name="short_description" form={addItemForm} className="text-danger" />
            </div>
            <div className="button-form">
             
              <button type="submit" className="btn btn-primary w-100">
                {t("Next")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* Add Options Model 2*/}
      <Drawer open={openWithHeaderNextAdd}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Create New Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderNextAdd(false);
                // addItemForm.resetForm();
                // resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={addItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("Options")}
                {/* <span>*</span>{" "} */}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Options") + " " + t("tooltip")}</Tooltip>}>
                  <div
                    className="label-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-title="This top tooltip is themed via CSS variables."
                  >
                  </div>
                </Whisper>
              </label>
              <div className="d-flex gap-3">
                <select
                  className="form-control cp"
                  value={addItemForm?.values?.selected_addon_id}
                  data-label="Choose an option"
                  onChange={(event) => {
                    addItemForm.setFieldValue('selected_addon_id', event.target.value);
                  }}
                  name="">

                  <option key={-1} value={-1}>
                    Select Addon
                  </option>
                  {OptionsData.map((option, i) => {
                    return <option key={i} value={option.value} disabled={option.disabled == true ? true : false}>
                      {option.label}
                    </option>
                  })}

                </select>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    addAddon(addItemForm);
                  }}
                >
                  {t("Add")}
                </button>
              </div>
              {typeof addItemForm?.errors?.addons === "string" && addItemForm?.errors?.addons ? <span className="d-block text-danger">{t(addItemForm?.errors?.addons)}</span> : null}
            </div>

            {
              addItemForm?.values?.addons?.map((addon, index) => {
                return <div className="item-menu-box">
                  <div className="item-menu-head d-flex  justify-content-between gap-3 align-center">
                    <h3>{addon?.addon_name}</h3>
                    <button type="button" onClick={() => { removeAddon(index, addItemForm) }}>Remove</button>
                  </div>
                  {/* listing assigned items to current addon */}
                  {
                    addon?.assigned_items?.map((item, itemIndex) =>
                      <div className="row mb-2">
                        <div className="col-md-6 align-items-center d-flex">
                          <div className="input-group">
                            <select className="form-control" value={item?.item_name} onChange={(event) => {
                              let addons = [...addItemForm?.values?.addons];
                              //removing current from disabled items
                              addons[index].disabled_items = addons[index].disabled_items.filter(disabledItem => disabledItem != item.item_name);
                              //adding new one to disabled items
                              if (event.target.value) {
                                addons[index].disabled_items.push(event.target.value);
                              }
                              addons[index].assigned_items[itemIndex].item_name = event.target.value;
                              addItemForm?.setFieldValue('addons', addons);
                            }}>
                              <option key='' value=''>Select item</option>
                              {
                                addon?.total_items?.map((item, index) =>
                                  <option key={index} value={item} disabled={addon?.disabled_items.includes(item) ? true : false}>{capitalizeFirstLetter(item)}</option>
                                )
                              }
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3 align-items-center d-flex">
                          <div className="">
                            <input type="number" value={item?.item_price} className="form-control" placeholder="Price" onChange={(event) => {
                              let addons = [...addItemForm?.values?.addons];
                              addons[index].assigned_items[itemIndex].item_price = Number(event.target.value) < 0 ? 0 : event.target.value;
                              addItemForm?.setFieldValue('addons', addons);
                            }} />
                          </div>
                        </div>
                        <div className="col-md-2 align-items-center d-flex">
                          <div className="add-remove-btn d-flex align-center">
                            {
                              addon?.assigned_items?.length > 1
                                ? <button type="button" className="" onClick={() => {
                                  let addons = [...addItemForm?.values?.addons];
                                  addons[index].assigned_items = addons[index]?.assigned_items?.filter((assignedItem, assignedItemIndex) => assignedItemIndex != itemIndex);
                                  addons[index].disabled_items = addons[index].disabled_items.filter(disabledItem => disabledItem != item?.item_name);
                                  addItemForm?.setFieldValue('addons', addons);
                                }}><i className="ri-close-circle-line" style={{ fontSize: '50px' }}></i></button>
                                : null
                            }
                            {
                              itemIndex == addon?.assigned_items?.length - 1
                                ? <button type="button" className="" onClick={() => { addAddOnItem(index, addItemForm) }}><i className="ri-add-circle-fill" style={{ fontSize: '50px' }}></i></button>
                                : null
                            }
                          </div>
                        </div>
                      </div>
                    )
                  }
                  {/* default addon item to assign new addon-item to this current iterated addon */}


                </div>
              })
            }


            <button type="submit" className="btn btn-primary w-100" disabled={!isValidAddons(addItemForm?.values?.addons)}>Next</button>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* Add Upselling-Item Model 3 */}
      <Drawer open={openWithHeaderNextModifierItemAdd}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Create New Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderNextModifierItemAdd(false);
                // addItemForm.resetForm();
                // resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={addItemForm.handleSubmit}>

            <div className="search-box mb-3">
              <label className="form-label">Select upselling items</label>
              <input type="text" className="form-control search-input" placeholder="Search" onChange={(event) => { filterUpsellingItems(event.target.value) }} />
            </div>

            <div className="select-upselling-list category-list-grid menu-list-grid mb-3">

              {
                filteredUpsellingItems?.map(upsellingItem =>
                  <div className={` ${addItemForm?.values.upselling_items.includes(upsellingItem._id) ? 'active' : ''}  category-box  category-menu-box cp`} onClick={() => { selectUpsellingItem(upsellingItem._id, addItemForm) }}>
                    <div className="category-name menu-img"> <img src={upsellingItem.image} alt="image" /></div>
                    <div className="menu-item-info text-center">
                      <h4>{upsellingItem.item_name}</h4>
                      <p>£{upsellingItem.price}</p>
                    </div>
                  </div>
                )
              }

            </div>

            <h3 className="mb-4 mt-4">{addItemForm?.values?.upselling_items.length} items selected</h3>

            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
              {t("Submit")}
            </button>
          </form>
        </Drawer.Body>
      </Drawer>



      {/* Edit Item Modal 1*/}
      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Edit Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setSelectedMenuItem(null);
                setOpenWithHeaderEdit(false);
                editItemForm.resetForm();
                resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editEmail", "rsuite");
          }}
        >
          <form onSubmit={editItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("Choose Category")}
                <span>*</span>{" "}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Choose Category") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <select
                className="form-control cp"
                name="category_id"
                value={editItemForm?.values?.category_id}
                onChange={(e) => {
                  editItemForm.handleChange(e);
                  editItemForm.setFieldValue("consumption_tax_rate", findTax(editItemForm, e.target.value)?.tax_rate);
                }}
                onBlur={editItemForm.handleBlur}
              >
                <option value={""}>{t("Select")}</option>
                {categoryList.map((item, index) => {
                  return (
                    <option key={index} value={item?._id}>
                      {TrimText(item?.name, 50)}
                    </option>
                  );
                })}
              </select>
              <CustomError name="category_id" form={editItemForm} className="text-danger" />
            </div>

            {/* Allergies Multiselect */}
            <div className="mb-3">
              <label className="form-label">
                Allergies Selection
              </label>

              <Select
                isMulti
                name="allergies"
                className="basic-multi-select"
                classNamePrefix="select"
                options={allergiesOptions}
                value={allergiesOptions.filter((opt) =>
                  editItemForm?.values?.allergies?.includes(opt.value)
                )}
                onChange={(value) =>
                  editItemForm.setFieldValue(
                    "allergies",
                    value.map((v) => v.value)
                  )
                }
                formatOptionLabel={(option) => (
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {option.imageUrl && (
                      <img
                        src={option.imageUrl}
                        alt={option.label}
                        style={{ width: "22px", height: "22px", borderRadius: "50%" }}
                      />
                    )}
                    <span>{option.label}</span>
                  </div>
                )}
              />

              <CustomError name="allergies" form={editItemForm} className="text-danger" />
            </div>

            <div className="mb-3">
              <label className="form-label">
                {t("Menu Item Code")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Menu Item Code") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Enter menu item code")}
                name="item_code"
                value={editItemForm?.values?.item_code}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
                disabled
              />
              <CustomError name="item_code" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Name Of The Item")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Name Of The Item") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Enter name of the item")}
                name="item_name"
                value={editItemForm?.values?.item_name}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
              />
              <CustomError name="item_name" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Add Photo")}
                <span>*</span>
              </label>
              <input
                className="form-control imgInput"
                id="image"
                name="image"
                accept="image/*"
                type="file"
                // value={addItemForm?.values?.image}
                onChange={(event) => {
                  editItemForm.setFieldValue("image", event.target.files[0] || "");
                }}
              />

              <CustomError name="image" form={editItemForm} className="text-danger" />
              <span className="mt-2 d-block">{t("Only JPEF, PNG files with max size 1.5 MB , Resolution supported 300X200")}</span>
              {editItemForm.values.image && (
                <ul className="question-image-preview questions-ul">
                  <li className="pr_img_box">
                    <img src={editItemForm.values.image instanceof File ? URL.createObjectURL(editItemForm.values.image) : editItemForm.values.image} style={{ height: "100px" }} alt={"Profile_Img"} />
                    <button
                      type="button"
                      className="btn-icon"
                      style={{ position: "absolute", right: "5px", top: "5px", height: "30px", width: "30px", minWidth: "30px" }}
                      onClick={() => {
                        editItemForm.setFieldValue("image", null);
                        document.getElementById("image").value = "";
                      }}
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </li>
                </ul>
              )}
            </div>

            <div className="mb-3">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Vatable Price")}
                    <span>*</span>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Vatable price") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price")}
                      aria-label="Vatable Price"
                      aria-describedby="basic-addon1"
                      name="taxable_price"
                      value={editItemForm?.values?.taxable_price}
                      onChange={(event) => {
                        editItemForm.handleChange(event);
                        editItemForm.setFieldValue('price', +editItemForm.values.non_taxable_price + +event.target.value)
                      }}
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                  <CustomError name="taxable_price" form={editItemForm} className="text-danger" />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Vatable Price Label")}
                    {/* <span>*</span> */}
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Vatable price label") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price label")}
                      aria-label="Vatable Price Label"
                      aria-describedby="basic-addon2"
                      name="taxable_price_label"
                      value={editItemForm?.values?.taxable_price_label}
                      onChange={editItemForm.handleChange}
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                  {/* <CustomError name="taxable_price_label" form={editItemForm} className="text-danger" /> */}
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="row">
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Non Vatable Price")}
                    <span>*</span>
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Non vatable price") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter non vatable price")}
                      aria-label="Vatable Price"
                      aria-describedby="basic-addon1"
                      name="non_taxable_price"
                      value={editItemForm?.values?.non_taxable_price}
                      onChange={(event) => {
                        editItemForm.handleChange(event);
                        editItemForm.setFieldValue('price', +editItemForm.values.taxable_price + +event.target.value)
                      }}
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                  <CustomError name="non_taxable_price" form={editItemForm} className="text-danger" />
                </div>
                <div className="col-md-6">
                  <label className="form-label">
                    {t("Non Vatable Price Label")}
                    {/* <span>*</span> */}
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>{t("Non vatable price label") + " " + t("tooltip")}</Tooltip>}
                    >
                      <div
                        className="label-tooltip"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-custom-class="custom-tooltip"
                        data-bs-title="This top tooltip is themed via CSS variables."
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control no_spring_input"
                      placeholder={t("Enter vatable price label")}
                      aria-label="Non vatable Label"
                      aria-describedby="basic-addon2"
                      name="non_taxable_price_label"
                      value={editItemForm?.values?.non_taxable_price_label}
                      onChange={editItemForm.handleChange}
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                  {/* <CustomError name="non_taxable_price_label" form={editItemForm} className="text-danger" /> */}
                </div>
              </div>
            </div>
            {/* vatable price or non vatable price  <<<< */}
            <div className="mb-3">
              <label className="form-label">
                {t("Price")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Price") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      £
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("Enter price")}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      name="price"
                      value={editItemForm?.values?.price}
                      // onChange={editItemForm.handleChange}
                      disabled
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                </div>

                <CustomError name="price" form={editItemForm} className="text-danger" />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Cost price")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Cost price") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  £
                </span>
                <input
                  type="number"
                  className="form-control no_spring_input"
                  placeholder={t("Enter cost price")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="cost_price"
                  value={editItemForm?.values?.cost_price}
                  onChange={editItemForm.handleChange}
                  onBlur={editItemForm.handleBlur}
                />
              </div>
              <CustomError name="cost_price" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Vat")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Vat") + " " + t("tooltip")}</Tooltip>}>
                  <div className="label-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-custom-class="custom-tooltip" data-bs-title="This top tooltip is themed via CSS variables.">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("Enter cost price")}
                value={`${editItemForm?.values?.consumption_tax_rate}% vat`}
                disabled
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              {/* <CustomError name="consumption_tax_rate" form={addItemForm} className="text-danger" /> */}
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={editItemForm?.values?.used_as_upselling_item}
                onChange={(e) => {
                  editItemForm?.setFieldValue("used_as_upselling_item", e.target.checked);
                }}
                id="used_as_upselling_item"
              />
              <label className="form-check-label" htmlFor="used_as_upselling_item">
                {t("Can be used as a upselling item?")}
              </label>
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("Calculated Vat")}</span>
                <span> {editItemForm?.values?.category_id ? <span>£ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.tax_price)} </span> : null}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("Price with Vat")}</span>
                {editItemForm?.values?.category_id && editItemForm?.values?.price ? <span>£ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.price_with_tax)}</span> : null}
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("Price without vat")}</span>
                {/* <span>£ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.price_without_tax)}</span> */}
                <span>£ {editItemForm?.values?.non_taxable_price}</span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("Short description")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description"
                value={editItemForm?.values?.short_description}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
                placeholder={"Enter short description"}
              ></textarea>
              <CustomError name="short_description" form={editItemForm} className="text-danger" />
            </div>
            <div className="button-form">
              <button type="submit" className="btn btn-primary w-100">
                {t("Next")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* Edit Options Model 2*/}
      <Drawer open={openWithHeaderNextEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Edit Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderNextEdit(false);
                // editItemForm.resetForm();
                // resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={editItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("Options")}
                {/* <span>*</span>{" "} */}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("Options") + " " + t("tooltip")}</Tooltip>}>
                  <div
                    className="label-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-title="This top tooltip is themed via CSS variables."
                  >
                  </div>
                </Whisper>
              </label>
              <div className="d-flex gap-3">
                <select
                  className="form-control cp"
                  value={editItemForm?.values?.selected_addon_id}
                  data-label="Choose an option"
                  onChange={(event) => {
                    editItemForm.setFieldValue('selected_addon_id', event.target.value);
                  }}
                  name="">

                  <option key={-1} value={-1}>
                    Select Addon
                  </option>
                  {OptionsData.map((option, i) => {
                    return <option key={i} value={option.value} disabled={option.disabled == true ? true : false}>
                      {option.label}
                    </option>
                  })}

                </select>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    addAddon(editItemForm);
                  }}
                >
                  {t("Add")}
                </button>
              </div>
              {typeof editItemForm?.errors?.addons === "string" && editItemForm?.errors?.addons ? <span className="d-block text-danger">{t(editItemForm?.errors?.addons)}</span> : null}
            </div>

            {
              editItemForm?.values?.addons?.map((addon, index) => {
                return <div className="item-menu-box">
                  <div className="item-menu-head d-flex  justify-content-between gap-3">
                    <h3>{addon?.addon_name}</h3>
                    <button type="button" onClick={() => { removeAddon(index, editItemForm) }}>Remove</button>
                  </div>
                  {/* listing assigned items to current addon */}
                  {
                    addon?.assigned_items?.map((item, itemIndex) =>
                      <div className="row mb-2">
                        <div className="col-md-6 align-items-center d-flex">
                          <div className="input-group">
                            <select className="form-control" value={item?.item_name} onChange={(event) => {
                              let addons = [...editItemForm?.values?.addons];
                              //removing current from disabled items
                              addons[index].disabled_items = addons[index].disabled_items.filter(disabledItem => disabledItem != item.item_name);
                              //adding new one to disabled items
                              if (event.target.value) {
                                addons[index].disabled_items.push(event.target.value);
                              }
                              addons[index].assigned_items[itemIndex].item_name = event.target.value;
                              editItemForm?.setFieldValue('addons', addons);
                            }}>
                              <option key='' value=''>Select item</option>
                              {
                                addon?.total_items?.map((item, index) =>
                                  <option key={index} value={item} disabled={addon?.disabled_items.includes(item) ? true : false}>{capitalizeFirstLetter(item)}</option>
                                )
                              }
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3 align-items-center d-flex">
                          <div className="">
                            <input type="number" value={item?.item_price} className="form-control" placeholder="Price" onChange={(event) => {
                              let addons = [...editItemForm?.values?.addons];
                              addons[index].assigned_items[itemIndex].item_price = Number(event.target.value) < 0 ? 0 : event.target.value;
                              editItemForm?.setFieldValue('addons', addons);
                            }} />
                          </div>
                        </div>
                        <div className="col-md-2 align-items-center d-flex">
                          <div className="add-remove-btn d-flex align-center">
                            {
                              addon?.assigned_items?.length > 1
                                ? <button type="button" className="" onClick={() => {
                                  let addons = [...editItemForm?.values?.addons];
                                  addons[index].assigned_items = addons[index]?.assigned_items?.filter((assignedItem, assignedItemIndex) => assignedItemIndex != itemIndex);
                                  addons[index].disabled_items = addons[index].disabled_items.filter(disabledItem => disabledItem != item?.item_name);
                                  editItemForm?.setFieldValue('addons', addons);
                                }}><i className="ri-close-circle-line" style={{ fontSize: '50px' }}></i></button>
                                : null
                            }
                            {
                              itemIndex == addon?.assigned_items?.length - 1
                                ? <button type="button" className="" onClick={() => { addAddOnItem(index, editItemForm) }}>
                                  <i className="ri-add-circle-fill" style={{ fontSize: '50px' }}></i>
                                </button>
                                : null
                            }
                          </div>
                        </div>
                      </div>
                    )
                  }

                </div>
              })
            }

            <button type="submit" className="btn btn-primary w-100" disabled={!isValidAddons(editItemForm?.values?.addons)}>{t("Next")}</button>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* Edit Upselling-Item Model 3 */}
      <Drawer open={openWithHeaderNextModifierItemEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h3 className="mb-0">{t("Edit Item")}</h3>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeaderNextModifierItemEdit(false);
                // editItemForm.resetForm();
                // resetOptions();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body>
          <form onSubmit={editItemForm.handleSubmit}>

            <div className="search-box mb-3">
              <label className="form-label">Select upselling items</label>
              <input type="text" className="form-control search-input" placeholder="Search" onChange={(event) => { filterUpsellingItems(event.target.value) }} />
            </div>

            <div className="select-upselling-list category-list-grid menu-list-grid mb-3">

              {
                filteredUpsellingItems?.map(upsellingItem => {
                  return ItemDetail?._id != upsellingItem._id
                    ?
                    <div className={` ${editItemForm?.values.upselling_items.includes(upsellingItem._id) ? 'active' : ''} category-box  category-menu-box cp`} onClick={() => { selectUpsellingItem(upsellingItem._id, editItemForm) }}>
                      <div className="category-name menu-img"> <img src={upsellingItem.image} alt="image" /></div>
                      <div className="menu-item-info text-center">
                        <h4>{upsellingItem.item_name}</h4>
                        <p>£{upsellingItem.price}</p>
                      </div>
                    </div>
                    : null
                })
              }

            </div>

            <h3 className="mb-4 mt-4">{editItemForm?.values?.upselling_items.length} items selected</h3>

            <button type="submit" className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}>
              {t("restaurant.button.btn_update")}
            </button>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* view modal for menu item  */}
      <div className="offcanvas offcanvas-end right-modal-w" id="view-new-item" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
        <div className="offcanvas-header">
          <h3 className="offcanvas-title" id="offcanvasRightLabel">
            {t("Item details")}
          </h3>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => { setSelectedMenuItem(null); }}>
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div
          className="offcanvas-body"
          onScroll={(e) => {
            handleOffcanvasScroll(e, "view-new-item");
          }}
        >
          <div className="view-info">
            <div className="row gap-4">
              <div className="col-md-12">
                <h4 >{t("Category")} :</h4>
                <p >{categoryList.find((item) => item?._id === ItemDetail.category_id)?.name}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("Menu Item Code")} :</h4>
                <p >{ItemDetail?.item_code}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("Item name")} :</h4>
                <p >{ItemDetail?.item_name}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("Photo")} :</h4>
                {editItemForm.values.image && (
                  <ul className="question-image-preview questions-ul">
                    <li className="pr_img_box">
                      <img
                        src={editItemForm.values.image instanceof File ? URL.createObjectURL(editItemForm.values.image) : editItemForm.values.image}
                        style={{ height: "100px" }}
                        alt={"Profile_Img"}
                      />
                    </li>
                  </ul>
                )}
              </div>
              
              <div className="col-md-12">
                <h4 >{t("Used as upselling item")} :</h4>

                <div className="input-group">
                  <p >{`${t(booleanMask(ItemDetail?.used_as_upselling_item))}`}</p>
                </div>
              </div>

              
              {ItemDetail?.taxable_price_label ?
                <div className="col-md-12">
                  <h4 >{t("Vatable Price Label")} :</h4>
                  <div className="row">
                    <div className="col">
                      <div className="input-group">
                        <p >{ItemDetail?.taxable_price_label}</p>
                      </div>
                    </div>
                    <p >{ }</p>
                  </div>
                </div>
                : null}
              {ItemDetail?.non_taxable_price_label ?
                <div className="col-md-12">
                  <h4 >{t("Non Vatable Price Label")} :</h4>
                  <div className="row">
                    <div className="col">
                      <div className="input-group">
                        <p >{ItemDetail?.non_taxable_price_label}</p>
                      </div>
                    </div>
                    <p >{ }</p>
                  </div>
                </div>
                : null}
              <div className="col-md-12">
                <h4 >{t("Vatable Price")} :</h4>
                <div className="row">
                  <div className="col">
                    <div className="input-group">
                      <p >£ {ItemDetail?.taxable_price}</p>
                    </div>
                  </div>
                  <p >{ }</p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("Non Vatable Price")} :</h4>
                <div className="row">
                  <div className="col">
                    <div className="input-group">
                      <p >£ {ItemDetail?.non_taxable_price}</p>
                    </div>
                  </div>
                  <p >{ }</p>
                </div>
              </div>

              <div className="col-md-12">
                <h4 >{t("Price")} :</h4>
                <div className="row">
                  <div className="col">
                    <div className="input-group">
                      <p >£ {ItemDetail?.total_price}</p>
                    </div>
                  </div>
                  <p >{ }</p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("Cost price")} :</h4>
                <div className="input-group">
                  <p >£ {ItemDetail?.cost_price}</p>
                </div>
              </div>
              {/* <div className="col-md-12">
                <h4 >{t("Item tax type")} :</h4>
                <div className="input-group">
                  <p >{ItemDetail?.item_tax_type}</p>
                </div>
              </div> */}
              <div className="col-md-12">
                <h4 >{t("Consumption vat rate")} :</h4>
                <p >{ItemDetail?.consumption_tax_rate} % {'Vat'}</p>
              </div>

              <div className="col-md-12">
                <h4 >{t("Calculated vat")} :</h4>
                <span>£ {showPrice(ItemDetail?.tax_price)}</span>
              </div>
              <div className="col-md-12">
                <h4 >{t("Price with Vat")} :</h4>
                <p >£ {showPrice(ItemDetail?.total_price)}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("Price without vat")} :</h4>
                <p >£ {showPrice(ItemDetail?.price)}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("Short description")} :</h4>
                <p >{capitalizeFirstLetter(ItemDetail?.short_description)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
